import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_5fe9uukyn9: FaireBrandEntity = {
  token: "b_5fe9uukyn9",
  type: "brand",
  name: "Paper Farm Press",
  avatarUrl:
    "https://cdn.faire.com/fastly/b50425f73e34f722c97938a8fa6d86a8a9e75c761e3851dfcacdf952a876cbc7.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/da5ef3e9fd63306874c06f32aaec86e384b4ae03169cf01585c1eaddb29fc75b.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/b50425f73e34f722c97938a8fa6d86a8a9e75c761e3851dfcacdf952a876cbc7.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/da5ef3e9fd63306874c06f32aaec86e384b4ae03169cf01585c1eaddb29fc75b.jpeg",
  location: "Bowling Green, KY, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 134,
  isTopShop: true,
  isInsider: true,
  description:
    'We are a woman-owned stationery and gift shop in Kingsburg, California, the fruit basket of the world. Each product we create expresses our love for farming and our deep roots in faith. We love partnering with unique retailers to spread the joy of stationery, tea towels, notebooks, calendars and more!\n\n*Please include "Paper Farm Press" in any e-commerce listing or social media post promoting product*\n\n© Paper Farm Press, LLC. / All rights reserved. Artwork and images may not be reproduced or used without my consent.',
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:56.425Z",
    importedBy: "entity-db-cli",
  },
};
